var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"rideit-notice-status"},[_c('v-chip',{attrs:{"color":_vm.statusColor}},[_vm._v(_vm._s(_vm.statusText))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }